import icon1GB from "../../assets/images/1gb-coin.png";
import icon4GB from "../../assets/images/4gb-coin.png";
import "./Humps.scss";

interface IProps {
  isLoading: boolean;
  isBuyForHump: boolean;
  isBuyForHumpDisabled: boolean;
  callbackChange: (isBuyForHump: boolean) => void;
}

const Humps = (props: IProps) => {
  const handleClickHump = (isBuyForHump: boolean): void => {
    if (props.isLoading) {
      return;
    }
    if (isBuyForHump) {
      if (!props.isBuyForHumpDisabled) {
        props.callbackChange(true);
      }
    } else {
      props.callbackChange(false);
    }
  };

  return (
    <div id="humps">
      <div
        onClick={() => handleClickHump(false)}
        className={`offer ${!props.isBuyForHump && "clicked"}`}
      >
        <span className="header">Tekli</span>
        <div className="offer-value">
          <span className="header">Anında</span>
          <img className="value" src={icon1GB} alt="1gb" />
        </div>
        <span className="button-text">99.99₺</span>
      </div>
      <div onClick={() => handleClickHump(true)}>
        <div
          className={`offer ${props.isBuyForHump && "clicked"} ${
            props.isBuyForHumpDisabled && "disabled"
          }`}
        >
          <span className="top-earning">EN ÇOK KAZANDIRAN</span>
          <span className="header multiple">Üçlü</span>
          <div className="offer-value">
            <span className="header">Anında</span>
            <img className="value" src={icon4GB} alt="4gb" />
          </div>
          <span className="button-text">299.99₺</span>
        </div>
        {props.isBuyForHumpDisabled && (
          <div className="disabled-hump-note">
            Günlük limite ulaştığın için bu paket devredışı bırakıldı.
          </div>
        )}
      </div>
    </div>
  );
};

export default Humps;
